<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter border-bottom">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Project Gallery</h1>
                </div>
                <p>
                    Our team at PC Haines has provided expert wall and ceiling contractor  services on a wide scope of projects, including those for, educational,  police, federal government, and municipal customers. See photos of our  quality and read project descriptions by clicking on the individual  projects below.
                </p>
            </div>
            <div class="circles project-circles">
                <pc-project-circles></pc-project-circles>
            </div>
        </div>
    </div>
</div>

<!-- Projects -->
<div class="projects-container">

    <div class="site-gutter white-gutter">

        <div class="wrapper">
            <div class="filter-container" [ngClass]="{'open' : openFilters}">
                <span class="label">Filter Projects</span>
    
                <button class="black-button" (click)="toggleFilter()">
                    @if (sortNewest) {Newest Projects} 
                    @if (sortOldest) {Oldest Projects} 
                    @if (sortAtoZ) {A to Z Projects} 
                    @if (sortZtoA) {Z to A Projects}
                    <span class="arrow"></span>
                </button>
                <div class="filter-dropdown">
                    <p (click)="sortProjectsByNewesttDate()">Newest Projects</p>
                    <p (click)="sortProjectsByOldestDate()">Oldest Projects</p>
                    <p (click)="sortProjectsTitleAtoZ()">A-Z Projects</p>
                    <p (click)="sortProjectsTitleZtoA()">Z-A Projects</p>
                </div>
            </div>


            <div class="project-list">
                @for (project of projectList; track trackByFn) {
                    <pc-project-card
                    [imageUrl]="project.bannerImgUrl"
                    [title]="project.title"
                    [divisions]="project.servicesList"
                    [projectUrl]="'/projects/' + project.id"
                    [projectDate]="project.projectDate"
                    ></pc-project-card>
                }
            </div>
        </div>
    </div>

 </div>

 <pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
 ></pc-seat-belt>

 <div class="filter-mask" (click)="closeFilters()" [ngClass]="{'open' : openFilters}"></div>